import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import appSlice from "./appSlice";
import authSlice from "./authSlice";
import websiteSettingsSlice from "./websiteSettingsSlice";
import { authApi } from "./authService";
import { permissionsApi } from "./permissionsService";

export const store = configureStore({
	reducer: {
		auth: authSlice.reducer,
		app: appSlice.reducer,
		settings: websiteSettingsSlice.reducer,
		[authApi.reducerPath]: authApi.reducer,
		[permissionsApi.reducerPath]: permissionsApi.reducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware()
		.concat(authApi.middleware)
		.concat(permissionsApi.middleware),
	devTools: process.env.REACT_APP_ENV !== "production",
});
setupListeners(store.dispatch);
export default store;
